<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10" v-if="data != null">
              <div class="row headercontenido py-5 py-md-0 pb-md-2">
                <div class="col-md-6">
                  <span class="titulo bold fG">Perfil de usuario</span>
                </div>
                <div class="col-md-6">
                  <button
                    class="submit btngris float-right"
                    @click="preguntarBaja()"
                    v-if="
                      this.$store.state.user.user_level == 1 &&
                      data.id != '1'
                    "
                  >
                    Dar de baja
                  </button>
                </div>
              </div>

              <div ref="main" class="contenido pt-4" v-if="data != null">
                <div class="row">
                  <div class="col-12 text-left pb-4 mb-2">
                    <div class="card h-100 border-round p-4 shadow">
                      <div class="">
                        <div class="bold">
                          <i class="fas fa-user-edit fR"></i> Tus datos:
                        </div>
                        <hr />
                        <div>
                          <form
                            class="formulario"
                            @submit="submitDatosPerfil($event)"
                          >
                            <div class="row py-4">
                              <div class="col-md-4 pb-4">
                                <label>
                                  <span class="pb-2 fR">Nombre(s)</span>
                                  <input
                                    type="text"
                                    v-model="formdatos.nombre"
                                    placeholder="Nombre(s)"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>
                              <div class="col-md-4 pb-4">
                                <label>
                                  <span class="pb-2 fR">Apellido Paterno</span>
                                  <input
                                    type="text"
                                    v-model="formdatos.apellido_paterno"
                                    placeholder="Apellido Paterno"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>
                              <div class="col-md-4 pb-4">
                                <label>
                                  <span class="pb-2 fR">Apellido Materno</span>
                                  <input
                                    type="text"
                                    v-model="formdatos.apellido_materno"
                                    placeholder="Apellido Materno"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-6 pb-4">
                                <label>
                                  <span class="pb-2 fR"
                                    >Correo Electrónico</span
                                  >
                                  <input
                                    type="email"
                                    v-model="formdatos.email"
                                    placeholder="Correo Electrónico"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-6 pb-4">
                                <label>
                                  <span class="pb-2 fR">Teléfono</span>
                                  <input
                                    type="text"
                                    v-model="formdatos.telefono"
                                    placeholder="+52"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-12 bgblanco rounded pb-2">
                                <div class="pb-3">
                                  <span>Perfil</span>
                                  <label>
                                    <select
                                      v-model="formdatos.user_level"
                                      required
                                    >
                                      <option value="">Perfil</option>
                                      <option value="1">Administrador</option>
                                      <option value="10">Básico</option>
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div class="col-md-12 pb-4">
                                <label>
                                  <span class="pb-2 fR"
                                    >Escribe tu contraseña para guardar los
                                    cambios</span
                                  >
                                  <input
                                    type="password"
                                    v-model="formdatos.pwd_actual"
                                    placeholder="Contraseña"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-12 pb-4">
                                <button
                                  type="submit"
                                  class="submit btnnaranja w-100"
                                >
                                  Guardar cambios
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 text-left pb-4 mb-2">
                    <div class="card h-100 border-round p-4 shadow">
                      <div class="">
                        <div class="bold">
                          <i class="fas fa-key fR"></i> Cambiar contraseña
                        </div>
                        <hr />
                        <div>
                          <form class="formulario" @submit="submitPwd($event)">
                            <div class="row py-4">
                              <div class="col-md-12 pb-4">
                                <label>
                                  <span class="pb-2 fR">Tu contraseña</span>
                                  <input
                                    type="password"
                                    v-model="formpwd.pwd_actual"
                                    placeholder="Tu contraseña"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-12 pb-4">
                                <label>
                                  <span class="pb-2 fR">Nueva Contraseña</span>
                                  <input
                                    type="password"
                                    v-model="formpwd.pwd"
                                    placeholder="Nueva Contraseña"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-12 pb-4">
                                <label>
                                  <span class="pb-2 fR"
                                    >Repetir Contraseña</span
                                  >
                                  <input
                                    type="password"
                                    v-model="formpwd.pwd2"
                                    placeholder="Repetir Contraseña"
                                    maxlength="100"
                                    required
                                  />
                                </label>
                              </div>

                              <div class="col-md-12 pb-4">
                                <button
                                  type="submit"
                                  class="submit btnnaranja w-100"
                                >
                                  Cambiar contraseña
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      showOverlay: false,
      id_user: null,
      paso: 5,
      formcorreo: {
        email: "",
      },
      formdatos: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        email: "",
        telefono: "",
        pwd_actual: "",
        user_level: "",
      },
      formpwd: {
        pwd_actual: "",
        pwd: "",
        pwd2: "",
      },
      tiposervicio: "",
      columns: [
        "timestamp",
        "contratante",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      columns_endosos: [
        "timestamp",
        "no_endoso",
        "fecha_ini_endoso",
        "fecha_fin_endoso",
        "dias_endoso",
        "endoso",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          timestamp: "Fecha",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      options_endosos: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          timestamp: "Fecha",
          no_endoso: "No. Endoso",
          fecha_ini_endoso: "Fecha Inicio",
          fecha_fin_endoso: "Fecha Fin",
          dias_endoso: "Días",
          endoso: "Valor",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar endoso",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.init();
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      this.init();
    },
  },
  methods: {
    init() {
      this.$nextTick(() => (this.$refs.main.scrollTop = 0));

      this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
      AOS.init();

      this.id_user = this.$route.params.id;
      this.consulta();
    },
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_user: this.id_user,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-usuario-id.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];

              this.formdatos.nombre = this.data.nombre;
              this.formdatos.apellido_paterno = this.data.apellido_paterno;
              this.formdatos.apellido_materno = this.data.apellido_materno;
              this.formdatos.email = this.data.user_email;
              this.formdatos.telefono = this.data.telefono;
              this.formdatos.user_level = this.data.user_level;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      this.paso++;
    },
    regresar() {
      this.paso--;
    },
    preguntarBaja() {
      swal
        .fire({
          title: "Baja de usuario",
          html: "¿Dar de baja a este usuario?",
          confirmButtonText: `Ok`,
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText: "Cancelar",
          icon: "warning",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.baja();
          }
        });
    },
    baja() {
      // proceso de baja

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_user: this.id_user,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "baja-usuario.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.$router.push("/usuarios");
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    terminar() {
      //terminar
    },
    submitDatosPerfil(e) {
      e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.formdatos;
      this.formdatos.email_actual = this.$store.state.user.user_email;
      this.formdatos.id_user = this.id_user;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "modificar-datos-admin.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              // if (
              //   this.$store.state.user.user_email == this.formdatos.email_actual
              // ) {
              //   this.$cookie.set("usergaig", JSON.stringify(res.user), 1);
              //   this.$store.state.user = this.$cookie.get("usergaig");
              // }

              swal
                .fire({
                  title: "Datos usuario",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // if(this.$store.state.user.user_email != this.formdatos.email)
                    // this.logout();
                    window.location.reload();
                  }
                });

              this.formdatos.pwd_actual = "";
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitPwd(e) {
      e.preventDefault();

      if (this.formpwd.pwd != this.formpwd.pwd2) {
        swal.fire(
          "Cambiar contraseña",
          "El campo de verificación de contraseña no coincide.",
          "warning"
        );
        return;
      }

      //revisar longitud, alfanumerico y mayúsculas
      if (!this.formpwd.pwd.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{15,}$/)) {
        swal.fire(
          "Cambiar contraseña",
          "La contraseña debe de tener al menos 15 caracteres alfanúmericos, al menos 1 número y al menos una mayúscula.",
          "warning"
        );
        return;
      }

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.formpwd;
      qData.email_actual = this.$store.state.user.user_email;
      qData.id_user = this.id_user;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "cambiar-contrasena-admin.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              this.formpwd.pwd_actual = "";
              this.formpwd.pwd = "";
              this.formpwd.pwd2 = "";

              swal
                .fire({
                  title: "Cambio de contraseña",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    //this.$router.push("/dashboard");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay;
    },
    logout() {
      this.$cookie.delete("usergaig");
      this.$router.push("/");
    },
  },
};
</script>

